const VERSION = '2.0.14p'
export default VERSION
